import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChangeRequestService } from './../../services/changerequest.service';
import { DataService } from '../../services/data.service';
import { Status } from '../../models/status.enum';
import { TrackAuthority } from '../../models/trackauthority';
import { EmployeeInCharge } from '../../models/employeeInCharge';
import { ChangeRequest } from '../../models/changerequest';
import { IsharingChangeModel } from '../../models/sharing-change-model';
import { EventBusService, EventType, ATMEventData } from '../../services/eventbus.service';

@Component({
  selector: 'app-release-shared-authority',
  templateUrl: './release-shared-authority.component.html',
  styleUrls: ['./release-shared-authority.component.scss']
})
export class ReleaseSharedAuthorityComponent implements OnInit {
  @Input() modelOpenStatus: Boolean = false;
  @Input() authority: TrackAuthority;
  @Input() reviewSharingRequest: Boolean = true;
  @Input() eicList: EmployeeInCharge[];
  @Output() CloseModelStatus: EventEmitter<boolean> = new EventEmitter();
  private eicListObj = {};
  eicListArray: Array<any> = [];
  valueSelected = false;
  constructor(private changeRequestService: ChangeRequestService, private dataService: DataService, private eventBus: EventBusService) {}

  ngOnInit() {
    this.eicListArray = this.eicList;
  }

  private createChangeRequestForAcceptReject(racf_id: string, requestType: string) {
    let comment = '';
    let status = Status.SHARING_INITIATED;
    if (requestType === 'reject') {
      status = Status.SHARING_REQUEST_REJECTED;
      this.eicListArray.forEach(eic => {
        if (eic.eicUserId === racf_id && eic.selected == 1) {
          comment = eic.rejectReason;
        }
      });
    }
    const changeRequest = {
      id: this.authority.id,
      authorityChangeRequestId: this.authority.eicChangeRequests[racf_id].authorityChangeRequestId,
      Status: status
    };
    const ChangeRequestBody = {
      status: status,
      confirmation: [],
      comment: comment
    };
    return this.dataService.changeRequest(changeRequest, ChangeRequestBody, this.authority);
  }

  onSubmit(): void {
    if (!this.valueSelected) {
      return;
    }
    this.eventBus.fireEvent(EventType.BLOCK_UI_EVENT, null);
    let promiseArr = [];
    for (let key in this.eicListObj) {
      if (this.authority.eicChangeRequests[key] && this.eicListObj[key] !== 0) {
        let requestType = 'reject';
        if (this.eicListObj[key] === 2) {
          requestType = 'accept';
        }
        promiseArr.push(this.createChangeRequestForAcceptReject(key, requestType));
      }
    }
    Promise.all(promiseArr)
      .then(results => {
        this.eventBus.fireEvent(EventType.RELEASE_UI_EVENT, null);
        this.eventBus.fireEvent(EventType.AUTHORITY_UPDATED_EVENT, new ATMEventData(this.authority, () => {}));
        this.closeModel();
      })
      .catch((err: Error) => {
        this.eventBus.fireEvent(EventType.RELEASE_UI_EVENT, null);
        this.closeModel();
      });
  }

  private primaryInitiatesUnsharing(eicSecondary: String, eic) {
    const sharingChangeModel: IsharingChangeModel = {
      secondaryEICRacf: eicSecondary
    };
    const changeRequest: ChangeRequest = {
      trackAuthorityId: this.authority.id,
      type: Status.TYPE_UNSHARE.toString(),
      sharingChangeModel: sharingChangeModel
    };
    const secondaryName = `${eic.eicUserId} - ${eic.eicEmployeeName}`;
    return this.changeRequestService.postChangeRequest(changeRequest, this.authority, secondaryName);
  }

  onSubmitReleaseShareAuthority() {
    this.eventBus.fireEvent(EventType.BLOCK_UI_EVENT, null);
    let promiseArr = [];
    if (Array.isArray(this.eicList) && this.eicList.length > 0) {
      this.eicList.forEach(eic => {
        if (eic.status === 'ACT' && !eic.primary) {
          promiseArr.push(this.primaryInitiatesUnsharing(eic.eicUserId, eic));
        }
      });
    }
    Promise.all(promiseArr)
      .then(results => {
        this.eventBus.fireEvent(EventType.RELEASE_UI_EVENT, null);
        this.eventBus.fireEvent(EventType.AUTHORITY_UPDATED_EVENT, new ATMEventData(this.authority, () => {}));
        this.closeModel();
      })
      .catch((err: Error) => {
        this.eventBus.fireEvent(EventType.RELEASE_UI_EVENT, null);
        this.closeModel();
      });
  }

  closeModel() {
    this.CloseModelStatus.emit(false);
  }

  addToEicList(eicList, status) {
    this.valueSelected = true;
    this.eicListObj[eicList.eicUserId] = status;
  }
}
